var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBubbleBlue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1109,
    height: 1109,
    viewBox: "0 0 1109 1109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1899_21511)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.245 378.436C735.32 231.84 540.339 189.141 393.742 283.066L375.436 294.795C228.84 388.72 186.141 583.701 280.066 730.298V730.298C373.991 876.894 568.972 919.593 715.569 825.668L733.875 813.939C880.471 720.014 923.17 525.033 829.245 378.436V378.436Z",
    fill: "url(#paint0_radial_1899_21511)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1899_21511",
    x: 19.4284,
    y: 22.4286,
    width: 1070.45,
    height: 1063.88,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 105.395,
    result: "effect1_foregroundBlur_1899_21511"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1899_21511",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(554.655 554.367) rotate(57.3522) scale(315.244 1037)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C6BC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2400FF",
    stopOpacity: 0.37
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbleBlue);
export default __webpack_public_path__ + "static/media/Bubble-blue.b619eed28d3b3bc31d5aa04272f33eda.svg";
export { ForwardRef as ReactComponent };